import React from "react";

function ClassDescriptions({ data }) {
  return (
    <div
      className="card cutumBorder cardSingle m-3 p-4"
      style={{
        backgroundColor: "#fff",
      }}
    >
      <div className="d-flex  align-items-center">
        {" "}
        <i
          style={{ color: "#E42A3F", fontSize: "35px" }}
          className="fas fa-file-alt m-1"
        />
        <h2 style={{ color: "#E42A3F" }}>توضیحات کلاس</h2>
      </div>
      <hr style={{ color: "#E42A3F" }} />
      <div
        className="content"
        style={{ padding: "15px" }}
        dangerouslySetInnerHTML={{
          __html: data && data.description && data.description.description,
        }}
      />
      {data && detailsSeason(data && data.details_session)}
    </div>
  );
}

export default ClassDescriptions;

const detailsSeason = (sesion) => {
  const dayOfWeek = [
    {
      id: "str",
      name: "شنبه",
    },
    {
      id: "sun",
      name: "یکشنبه",
    },
    {
      id: "mon",
      name: "دوشنبه",
    },
    {
      id: "thr",
      name: "سه شنبه",
    },
    {
      id: "wen",
      name: "چهارشنبه",
    },
    {
      id: "thu",
      name: "پنجشنبه",
    },
    {
      id: "frd",
      name: "جمعه",
    },
  ];

  return (
    <div className="card-gym mt-4">
      <h6>برنامه هفتگی تشکیل کلاس ها :</h6>
      {dayOfWeek.map((days, key) => {
        return (
          <div key={key} className="row card-body">
            <div className="col">{days.name} :</div>
            {sesion.map((ses, dwdwa) => {
              if (days.id == ses.day) {
                return (
                  <div key={dwdwa} className="col">{ses.start} تا {ses.end}</div>
                );
              }
            })}
          </div>
        );
      })}
    </div>
  );
}
